<section class="p-3 bg-warning text-dark" *ngIf="isPreview() == true">
	<div class="container-fluid">
		<strong>Let op!</strong> Je bekijkt nu een preview. <a
			href="https://content.{{ systemKey }}.nl/wp-admin/post.php?action=edit&post={{previewId}}">(Bewerken in
			Wordpress)</a>
	</div>
</section>

<section class="toasts-container" *ngIf="currentStudent"
	style="position: fixed; bottom: 10px; right: 10px; z-index: 99;">
	<article class="toast show">
		<div>
			<div class="toast-body toast-with-icon"
				style="display: flex; align-items: center; justify-content: center;">
				<div class="toast-icon" style="height: fit-content; margin-right: 15px; color: #eb729e;"><i
						class="fa-solid fa-circle-exclamation"></i></div>
				<div class="toast-content" style="line-height: 25px;">
					<strong>Let op!</strong> Je bekijkt deze les nu op <strong>{{currentStudent['studyLevel']}}</strong>
					met als leerling <strong>{{currentStudent['name']}}</strong>.
				</div>
			</div>
		</div>
	</article>
</section>

<section class="lesson" [ngClass]="lessonId != null ? lessonId : ''" (click)="closeMenus($event)">
	<div [ngClass]="isPreview() == true ? 'lesson-preview' : ''">

		<div class="main main-navigation pt-3">

			<a routerLink="/index" class="logo-link mb-3 d-block float-left"
				style="width:90px;height:90px;position:absolute;top:0;left:0;z-index:12;">
				<img src="{{ cdnUrl }}images/artwork/{{systemKey}}/logo-ipad.svg"
					alt="{{systemTitle}} ⋆ {{systemSlogan}}" class="img-fluid" />
			</a>

			<nav class="lesson-container-width m-5">
				<div class="float-left pl-3">

					<div (click)="scrollTop()" class="position-relative ml-5 pl-5 ml-lg-0 pl-lg-0" *ngIf="item">
						<h4 *ngIf="lessonCount > 0 || isChoiceAssignmentChapter"
							class="anchor-dropdown-lessons lesson-title d-none d-md-block">
							<i (click)="openModule()" class="fa-solid fa-arrow-left back-arrow"></i> {{
							item['chapter']['name'] }}
							<!-- <i *ngIf="showLessonList" class="fas fa-chevron-up"></i>
							<i *ngIf="!showLessonList" class="fas fa-chevron-down"></i> -->
							<small><br />{{item['lesson']['name']}}</small>
							<!-- <div class="toggle-lesson-list-button" (click)="toggleLessonList()"></div> -->
						</h4>
					</div>
				</div>

				<div class="menuWrapper" style="right: 0; position: absolute;">
					<div class="pl-5 pt-1 pr-3 lesson-action-buttons" *ngIf="item">
						<div title="Print deze les"
							*ngIf="currentUser['canDownloadPdf'] == true && item['lesson']['pdf'] != false"
							(click)="showDownloadPdf()"
							class="anchor-dropdown-pdf position-relative cursor-pointer block rounded-circle btn-tertiary shadow-sm text-center align-middle mr-3 d-md-block">
							<i class="fa-solid fa-file-pdf"></i>
						</div>

						<div title="Opdrachtenoverzicht" id="answerOverview"
							*ngIf="item['lesson']['hasAnswers'] && classrooms.length > 0 && (currentUser['role'] == 'TEACHER' || currentUser['role'] == 'EDITOR' || currentUser['role'] == 'ADMIN')"
							(click)="showAnswerModal()"
							class="answerButton position-relative cursor-pointer block rounded-circle btn-tertiary shadow-sm text-center align-middle mr-3 d-none d-md-block"
							[ngClass]="{'loadDisabled' : answersLoaded}">
							<i class="fa-solid fa-users" *ngIf="!answersLoaded"></i>
							<i class="fa-solid fa-spinner" *ngIf="answersLoaded == true"></i>
						</div>

						<div title="Vraag om na te kijken"
							*ngIf="item['lesson']['hasAnswers'] == true && currentUser['role'] == 'STUDENT'"
							class="d-inline-block cursor-pointer block rounded-circle btn-tertiary shadow-sm text-center align-middle">
							<div title="Vraag nakijken aan"
								*ngIf="checkRequestState == '' || checkRequestState == 'EXPIRED' || checkRequestState == 'CANCELED'"
								(click)="sendCheckRequest()"><i class="fa-sharp fa-solid fa-file-circle-check"></i>
							</div>
							<div title="Wacht op goedkeuren" *ngIf="checkRequestState == 'WAITING'"><i
									class="fas fa-hourglass-start fa-lg"></i></div>
							<div title="Wacht op goedkeuren" *ngIf="checkRequestState == 'OPEN'"><i
									class="fas fa-hourglass-start fa-lg"></i></div>
							<div title="Nakijken actief" *ngIf="checkRequestState == 'APPROVED'"><i
									class="fas fa-thumbs-up fa-lg"></i></div>
							<div title="Laden" *ngIf="checkRequestState == 'PROCESSING'"><i
									class="fa-sharp fa-solid fa-file-circle-check"></i></div>
						</div>
						<div *ngIf="item['lesson']['hasAnswers'] == true && classrooms.length > 0 && (currentUser['role'] == 'ADMIN' || currentUser['role'] == 'EDITOR' || currentUser['role'] == 'TEACHER')"
							class="d-inline-block cursor-pointer block rounded-circle btn-tertiary shadow-sm text-center align-middle set-hover-colors"
							style="opacity: 0.3;">
							<div title="Vraag nakijken aan" class="check-request-dummy"><i
									class="fa-sharp fa-solid fa-file-circle-check"></i></div>
						</div>
					</div>

					<div *ngIf="item" style="z-index: 8; height: 55px;" class="d-none d-md-block">
						<div *ngIf="currentUser['role'] == 'STUDENT'" class="student-data rounded">
							<p class="font-weight-bold current-user-name">{{ currentUser['name'] }} (<span
									*ngFor="let class of currentUser['classroomTexts']; index as i"><span
										*ngIf="i != 0">, </span>{{class}}</span>)
							</p>
							<p class="small">{{ currentUser['organisationName'] }}</p>
						</div>

						<div *ngIf="currentUser['role'] == 'TEACHER' || currentUser['role'] == 'EDITOR' || currentUser['role'] == 'ADMIN'"
							(click)="toggleOptionsMenu()"
							class="anchor-dropdown-classroom-student student-data position-relative cursor-pointer d-none d-md-block">
							<div *ngIf="currentClassroom">
								<p>
									<span class="font-weight-bold current-user-name">
										<span *ngIf="currentStudent['name']">{{currentStudent['name']}} <ng-container
												*ngIf="currentStudent['studyLevel'] !== currentClassroom['defaultStudyLevel']">({{currentStudent['studyLevel']
												}})</ng-container> - </span>
										<span *ngIf="currentStudent['name'] == null"> </span>
										{{currentClassroom['name']}} ({{currentClassroom['defaultStudyLevel']}})
									</span>
									<span *ngIf="currentClassroom['name'] == null">Selecteer een
										klas/leerling/niveau:</span>
								</p>
								<p style="position: absolute; right: 0; display: flex;">
									<span class="small mr-1">{{ currentUser['email'] }}</span>
								</p>
								<div (click)="$event.stopPropagation()" [ngClass]="showOptionsMenu ? 'show' : ''"
									class="options-menu dd-menu">
									<select (change)="setCurrentClassroom($event.target.value)" name="select-class"
										id="select-class" class="custom-select mb-3">
										<option selected>Selecteer een klas:</option>
										<ng-container *ngFor="let classroom of classrooms; let i = index">
											<option *ngIf="classroom['mainTeacherId'] === currentUser['id']"
												value="{{ classroom['id'] }}"
												[selected]="classroom['name'] == currentClassroom['name']">
												{{ classroom['name'] }}
											</option>
										</ng-container>
										<ng-container *ngFor="let classroom of classrooms; let i = index">
											<option *ngIf="classroom['mainTeacherId'] !== currentUser['id']"
												value="{{ classroom['id'] }}"
												[selected]="classroom['name'] == currentClassroom['name']">
												{{ classroom['name'] }}
											</option>
										</ng-container>
									</select>
									<select (change)="goToStudentAnswers($event.target.value)" name="select-student"
										id="select-student" class="custom-select">
										<option selected>Selecteer een leerling:</option>
										<option value="no-student" [selected]="currentStudent == 'no-student'">Geen
											leerling
											selecteren</option>
										<option *ngFor="let student of students; let i = index"
											value="{{ student['id'] }}"
											[selected]="student['name'] == currentStudent['name']">
											{{ student['name'] }}
										</option>
									</select>
								</div>
								<i class="options-icon fa-solid fa-chevron-down"></i>
							</div>
						</div>

					</div>
				</div>

			</nav>

		</div>

		<div [ngClass]="showLessonList ? 'show' : 'show'" class="lesson-dropdown-menu-container border-and-shadow pl-1"
			*ngIf="item">
			<div class="lesson-dropdown-menu lesson-subcontainer-width"
				[ngClass]="isChoiceAssignmentChapter ? 'choice-assignment-chapter-menu' : ''">
				<!-- <div id="dropdown-image" style="position: absolute; left: 0;">
					<img (click)="openModule()" *ngIf="item['chapter']['image']"
						src="{{item['chapter']['image']}}"
						class="img-fluid text-center mb-3 d-none d-sm-block clickable"
						alt="Logo {{item['chapter']['name']}}" />
				</div> -->
				<ng-container *ngIf="choiceAssignmentsCount > 0">
					<div *ngIf="lessonCount > 0">
						<p class="list-header mb-0"><b>Inhoudsopgave</b></p>
						<ul class="list-group-flush w-80 pl-0">
							<ng-container *ngFor="let lesson of getLessons(1)">
								<li
									[className]="item['id'] == lesson['id'] ? 'list-group-item font-weight-bold' : 'list-group-item'">
									<span
										*ngIf="currentUser['role'] == 'TEACHER' || currentUser['role'] == 'ADMIN' || currentUser['role'] == 'EDITOR'">
										<a routerLink="/les/{{lesson['id']}}/{{currentStudentId}}"
											(click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
									<span *ngIf="currentUser['role'] == 'STUDENT' || !currentUser">
										<a routerLink="/les/{{lesson['id']}}" (click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
								</li>
							</ng-container>
						</ul>
					</div>
					<div *ngIf="lessonCount > 5">
						<p class="list-header mb-0 d-none d-md-block">&nbsp;</p>
						<ul class="list-group-flush second-lessons-menu w-80">
							<ng-container *ngFor="let lesson of getLessons(2)">
								<li
									[className]="item['id'] == lesson['id'] ? 'list-group-item font-weight-bold' : 'list-group-item'">
									<span
										*ngIf="currentUser['role'] == 'TEACHER' || currentUser['role'] == 'EDITOR' || currentUser['role'] == 'ADMIN'">
										<a routerLink="/les/{{lesson['id']}}/{{currentStudentId}}"
											(click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
									<span *ngIf="currentUser['role'] == 'STUDENT' || !currentUser">
										<a routerLink="/les/{{lesson['id']}}" (click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
								</li>
							</ng-container>
						</ul>
					</div>
				</ng-container>
				<ng-container *ngIf="choiceAssignmentsCount == 0">
					<div *ngIf="lessonCount > 0">
						<p class="list-header mb-0"><b>Inhoudsopgave</b></p>
						<ul class="list-group-flush w-80 pl-0 wrapColumn">
							<ng-container *ngFor="let lesson of getPartialLessons(0, false)">
								<li
									[className]="item['id'] == lesson['id'] ? 'list-group-item font-weight-bold' : 'list-group-item'">
									<span
										*ngIf="currentUser['role'] == 'TEACHER' || currentUser['role'] == 'ADMIN' || currentUser['role'] == 'EDITOR'">
										<a routerLink="/les/{{lesson['id']}}/{{currentStudentId}}"
											(click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
									<span *ngIf="currentUser['role'] == 'STUDENT' || !currentUser">
										<a routerLink="/les/{{lesson['id']}}" (click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
								</li>
							</ng-container>
						</ul>
					</div>
					<div *ngIf="lessonCount > 5">
						<p class="list-header mb-0 d-none d-md-block">&nbsp;</p>
						<ul class="list-group-flush second-lessons-menu w-80">
							<ng-container *ngFor="let lesson of getPartialLessons(1, false)">
								<li
									[className]="item['id'] == lesson['id'] ? 'list-group-item font-weight-bold' : 'list-group-item'">
									<span
										*ngIf="currentUser['role'] == 'TEACHER' || currentUser['role'] == 'EDITOR' || currentUser['role'] == 'ADMIN'">
										<a routerLink="/les/{{lesson['id']}}/{{currentStudentId}}"
											(click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
									<span *ngIf="currentUser['role'] == 'STUDENT' || !currentUser">
										<a routerLink="/les/{{lesson['id']}}" (click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
								</li>
							</ng-container>
						</ul>
					</div>
					<div *ngIf="lessonCount > 10">
						<p class="list-header mb-0 d-none d-md-block">&nbsp;</p>
						<ul class="list-group-flush second-lessons-menu w-80">
							<ng-container *ngFor="let lesson of getPartialLessons(2, false)">
								<li
									[className]="item['id'] == lesson['id'] ? 'list-group-item font-weight-bold' : 'list-group-item'">
									<span
										*ngIf="currentUser['role'] == 'TEACHER' || currentUser['role'] == 'EDITOR' || currentUser['role'] == 'ADMIN'">
										<a routerLink="/les/{{lesson['id']}}/{{currentStudentId}}"
											(click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
									<span *ngIf="currentUser['role'] == 'STUDENT' || !currentUser">
										<a routerLink="/les/{{lesson['id']}}" (click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
								</li>
							</ng-container>
						</ul>
					</div>
					<div *ngIf="lessonCount > 15">
						<p class="list-header mb-0 d-none d-md-block">&nbsp;</p>
						<ul class="list-group-flush second-lessons-menu w-80">
							<ng-container *ngFor="let lesson of getPartialLessons(3, false)">
								<li
									[className]="item['id'] == lesson['id'] ? 'list-group-item font-weight-bold' : 'list-group-item'">
									<span
										*ngIf="currentUser['role'] == 'TEACHER' || currentUser['role'] == 'EDITOR' || currentUser['role'] == 'ADMIN'">
										<a routerLink="/les/{{lesson['id']}}/{{currentStudentId}}"
											(click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
									<span *ngIf="currentUser['role'] == 'STUDENT' || !currentUser">
										<a routerLink="/les/{{lesson['id']}}" (click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
								</li>
							</ng-container>
						</ul>
					</div>
				</ng-container>
				<ng-container *ngIf="choiceAssignmentsCount > 0 && lessonCount > 0">
					<div class="seperator-menu" *ngIf="choiceAssignmentsCount > 0">
						<p class="list-header mb-0 list-header-choice-assignment">{{choiceAssignmentTitle}}</p>
						<ul class="list-group-flush list-group-flush-choice-assignment"
							[ngClass]="{'wrapColumn': shouldWrap == true}">
							<ng-container *ngFor="let lesson of getLessons(1, true)">
								<li class="list-group-item"
									[className]="item['id'] == lesson['id'] ? 'list-group-item font-weight-bold' : 'list-group-item'">
									<span
										*ngIf="currentUser['role'] == 'TEACHER' || currentUser['role'] == 'EDITOR' || currentUser['role'] == 'ADMIN'">
										<a routerLink="/les/{{lesson['id']}}/{{currentStudentId}}"
											(click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
									<span *ngIf="currentUser['role'] == 'STUDENT' || !currentUser">
										<a routerLink="/les/{{lesson['id']}}" (click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
								</li>
							</ng-container>
						</ul>
					</div>
					<div *ngIf="choiceAssignmentsCount > 5">
						<p class="list-header mb-0 empty">&nbsp;</p>
						<ul class="list-group-flush" [ngClass]="{'wrapColumn': shouldWrap == true}">
							<ng-container *ngFor="let lesson of getLessons(2, true)">
								<li class="list-group-item"
									[className]="item['id'] == lesson['id'] ? 'list-group-item font-weight-bold' : 'list-group-item'">
									<span
										*ngIf="currentUser['role'] == 'TEACHER' || currentUser['role'] == 'EDITOR' || currentUser['role'] == 'ADMIN'">
										<a routerLink="/les/{{lesson['id']}}/{{currentStudentId}}"
											(click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
									<span *ngIf="currentUser['role'] == 'STUDENT' || !currentUser">
										<a routerLink="/les/{{lesson['id']}}" (click)="showLessonList = false">
											{{lesson['name']}}
										</a>
									</span>
								</li>
							</ng-container>
						</ul>
					</div>
				</ng-container>
				<ng-container *ngIf="choiceAssignmentsCount > 0 && lessonCount == 0">
					<div class="seperator-menu" *ngIf="choiceAssignmentsCount > 0">
						<p class="list-header mb-0 list-header-choice-assignment">{{choiceAssignmentTitle}}</p>
						<app-lesson-nav-block [item]="item" [lessons]="getPartialLessons(0, true)"
							[currentUser]="currentUser" [currentStudentId]="currentStudentId"
							[shouldWrap]="shouldWrap"></app-lesson-nav-block>
					</div>
					<div *ngIf="choiceAssignmentsCount > 6">
						<p class="list-header mb-0 empty">&nbsp;</p>
						<app-lesson-nav-block [item]="item" [lessons]="getPartialLessons(1, true)"
							[currentUser]="currentUser" [currentStudentId]="currentStudentId"
							[shouldWrap]="shouldWrap"></app-lesson-nav-block>
					</div>
					<div *ngIf="choiceAssignmentsCount > 12">
						<p class="list-header mb-0 empty">&nbsp;</p>
						<app-lesson-nav-block [item]="item" [lessons]="getPartialLessons(2, true)"
							[currentUser]="currentUser" [currentStudentId]="currentStudentId"
							[shouldWrap]="shouldWrap"></app-lesson-nav-block>
					</div>
					<div *ngIf="choiceAssignmentsCount > 18">
						<p class="list-header mb-0 empty">&nbsp;</p>
						<app-lesson-nav-block [item]="item" [lessons]="getPartialLessons(3, true)"
							[currentUser]="currentUser" [currentStudentId]="currentStudentId"
							[shouldWrap]="shouldWrap"></app-lesson-nav-block>
					</div>
					<div *ngIf="choiceAssignmentsCount > 24">
						<p class="list-header mb-0 empty">&nbsp;</p>
						<app-lesson-nav-block [item]="item" [lessons]="getPartialLessons(4, true)"
							[currentUser]="currentUser" [currentStudentId]="currentStudentId"
							[shouldWrap]="shouldWrap"></app-lesson-nav-block>
					</div>
				</ng-container>
			</div>
		</div>

		<div class="col-12 bg-lesson" *ngIf="item">

			<div class="my-4">
				<div class="lesson-container-width pl-md-0 pr-md-0 pl-lg-3 pr-lg-3">
					<article [ngClass]="{
							'show-check-answers-buttons' : showCheckAnswers, 
							'show-answer-containers' : showAnswerContainers
						}" class="bg-white lesson-content">
						<div class="video-container" *ngIf="item['lesson']['video'] && item['lesson']['video'] != ''"
							[innerHTML]="lessonVideo"></div>
						<div class="image-container" *ngIf="item['lesson']['video'] == ''">
							<img src="{{item['lesson']['image']}}" style="width:100%;" />
						</div>
						<section class="caption" *ngIf="item['lesson']['caption']">{{item['lesson']['caption']}}
						</section>
						<div class="p-3 p-md-5">
							<h1 class="px-3 pb-1">{{item['lesson']['name']}}</h1>
							<div class="px-3" *ngIf="currentUser || item['lesson']['free'] == 1">
								<section [innerHTML]="lessoncontent" *ngIf="item['lesson']['type'] != 'TERMS'">
								</section>
								<section *ngIf="item['lesson']['type'] == 'TERMS'">

									<nav class="mb-3">
										<span [ngClass]="{'active': termTabListActive == true}"
											(click)="changeTermTab('list')" class="btn btn-secondary btn-sm"><i
												class="fas fa-align-justify"></i> Overzicht</span> &nbsp;
										<span [ngClass]="{'active': termTabCardsActive == true}"
											(click)="changeTermTab('cards')" class="btn btn-secondary btn-sm"><i
												class="fas fa-mask"></i> Oefenen &nbsp;</span> &nbsp;
										<span [ngClass]="{'active': termTabQuizActive == true}"
											(click)="changeTermTab('quiz')" class="btn btn-secondary btn-sm"><i
												class="fas fa-trophy"></i> Toetsen</span>
									</nav>

									<div class="terms-overview" *ngIf="termTabListActive == true">
										<div id="glossaryList-nav" class="listNav medium" role="tablist">
											<div class="ln-letters ">
												<a class="ln-all ln-selected" (click)="setActiveLetter('all')"
													[ngClass]="activeLetter == 'all' ? 'active' : ''" role="tab"
													aria-controls="panel-all" aria-selected="true"
													href="javascript:;">Alles</a>
												<a class="ln-_ ln-disabled" (click)="setActiveLetter(letter)"
													[ngClass]="activeLetter == letter ? 'active' : ''"
													*ngFor="let letter of letters" tabindex="-1" role="tab"
													aria-controls="panel-_" aria-selected="false" href="javascript:;">
													{{letter}}
												</a>
											</div>
										</div>
										<ul class="glossaryList mt-2" role="tablist" id="glossaryList">
											<ng-container *ngFor="let term of terms">
												<li class="pt-4"
													*ngIf="activeLetter == 'all' || activeLetter == term.letter">
													<a class="glossaryLink  cmtt_Mediawijs"
														href="https://www.schoolwoorden.nl/begrip/{{term['slug']}}">{{term['value']}}</a>
													<div class="glossary_itemdesc" [innerHTML]="term['description']">
													</div>
													<div class="glossary_alternative" *ngIf="term['alternatives']">
														Synoniemen: {{splitAlternativeString(term['alternatives'])}}
													</div>
												</li>
											</ng-container>
										</ul>
									</div>
									<div class="terms-flip-cards" *ngIf="termTabCardsActive == true">
										<p>Flashcards zijn fijn om begrippen te oefenen. Klik op het begrip om de uitleg
											ervan te zien.</p>

										<ng-container *ngFor="let term of terms; let i = index;">
											<div class="flip-card">
												<div class="flip-card-inner"
													[ngClass]="{'flipped': term['flip'] == true}">
													<div class="flip-card-front">
														{{term['value']}}{{term['flip']}}
													</div>
													<div class="flip-card-back">
														{{term['description']}}
													</div>
												</div>
											</div>
										</ng-container>
									</div>
									<div class="terms-quiz" *ngIf="termTabQuizActive == true">
										<div [innerHTML]="lessoncontent"></div>
									</div>
								</section>
							</div>
							<div class="p-3" *ngIf="currentUser==false && item['lesson']['free'] != 1">
								<div [innerHTML]="item['lesson']['description']"></div>
								<div class="loggedOutWrapper position-relative">
									<div class="text-center no-permission">
										<h3>Je bent niet ingelogd</h3>
										<p>Log in of vraag een proflicentie aan om verder te lezen</p>
										<button class="btn btn-success" (click)="showLogin()"
											type="button">Inloggen</button>

										<a id="trialLink" href="https://over.{{systemKey}}.nl/proeflicentie"
											target="_blank">
											<div id="trialBanner">
												<div id="content">
													<img width="65px"
														[src]="''+cdnUrl+'images/artwork/'+systemKey+'/logo-ipad.svg'"
														class="img-fluid" alt="{{systemTitle}}" />

													<div>
														<b>{{systemTitle}} gratis proberen?</b>
														<p>Vraag hier een proeflicentie aan</p>
													</div>
												</div>
												<i class="fa-solid fa-caret-right"></i>
											</div>
										</a>
									</div>
								</div>
								<!-- <p class="mt-5" style="font-size:90%;"><em>Voor deze les moet
										een licentie worden afgenomen. Lees op <a
											href="{{salesWebsite}}">over.{{systemKey}}.nl</a> alle mogelijkheden die
										deze methode jou kan bieden.</em></p> -->
							</div>
							<p class="alert alert-warning"
								*ngIf="currentUser!=false && !item['license'] && item['lesson']['free'] != 1">
								Deze module is nog niet aan deze klas toegewezen, als docent kan je dit in het
								docentenomgeving aanzetten. Kom je er niet uit? <a
									href="https://help.uitgeverijneo.nl/nl/ik-ben-ingelogd-waar-is-het-lesmateriaal/">Ga
									dan naar ons helpcentrum voor meer informatie.</a>
							</p>
						</div>

						<div class="footer bg-primary text-white p-3" *ngIf="currentUser">
							<div class="row">
								<div class="col-12 meta-block pt-2">
									<i class="far fa-clock"></i> <abbr class="mx-1"
										title="Laatste wijziging op {{item['lesson']['lastChanged'] | date: 'd MMM yyyy':'nl' }}">{{item['lesson']['lastChangedText']
										}}</abbr> &nbsp;
									<span class="toggle-feedback" (click)="toggleFeedback()"><i
											class="far fa-comment"></i> <span class="mx-1">Geef feedback over deze
											les</span></span>
								</div>
							</div>
						</div>

						<div *ngIf="showAnswersOverlayBox == true" id="dark-background-overlay"></div>
						<div *ngIf="showAnswersOverlayBox == true" id="answers-overlay-box" class="border-and-shadow">
							<a href="javascript:void(0)" (click)="closeAnswersOverlayBox()">
								<i class="fas fa-times-circle"></i>
							</a>
							<h2 class="title pr-5 mr-5">
								<span>{{ exerciseNumber }} </span>
								<span class="question mr-4" [innerHTML]="text ( questionTitle )">
								</span>
								<span class="suggested-answer" *ngIf="showSuggestedAnswerInModal">
									{{ suggestedAnswer }}
								</span>
							</h2>

							<div class="switchContainer">
								<p>Verberg namen <i class="fas fa-user-alt-slash"></i></p>
								<input type="checkbox" id="switch" (click)="toggleShowNames()" /><label
									for="switch">Toggle</label>
								<p><i class="fas fa-user-check"></i> Toon namen</p>
							</div>

							<div class="switchContainer" *ngIf="suggestedAnswer.length > 0">
								<p>Verberg antwoordvoorbeeld <i class="fas fa-eye-slash"></i></p>
								<input type="checkbox" id="switch2" (click)="toggleSuggestedAnswerInModal()" /><label
									for="switch2">Toggle</label>
								<p><i class="fas fa-eye"></i> Toon antwoordvoorbeeld</p>
							</div>

							<div class="row">
								<ng-container *ngFor="let answer of answers; let i = index">
									<div *ngIf="answer['answer'].length > 1;" class="col-md-6 col-xl-3 mb-4">
										<div>
											<div class="card shadow-sm"
												[ngClass]="{'perfect' : answer['state'] == 'PERFECT', 'correct' : answer['state'] == 'CORRECT', 'wrong' : answer['state'] == 'WRONG'}">
												<div class="card-body">
													{{ answer['answer'] }}
												</div>
												<div class="card-footer">
													<h4 class="student-name" *ngIf="showStudentAnswerNames == true">{{
														answer['fullname'] }}</h4>
													<button (click)="updateAnswerState('perfect', answer)"
														[ngClass]="answer['state'] == 'PERFECT' ? 'highlight-perfect' : ''"
														class="btn btn-sm {{ questionCssClassPrefix }}answer-button btn-success"
														[attr.data-question-id]="'qna-' + i + '-question'">Goed!</button>
													<button (click)="updateAnswerState('correct', answer)"
														[ngClass]="answer['state'] == 'CORRECT' ? 'highlight-correct' : ''"
														class="btn btn-sm {{ questionCssClassPrefix }}answer-button btn-warning"
														[attr.data-question-id]="'qna-' + i + '-question'">Voldoende</button>
													<button (click)="updateAnswerState('wrong', answer)"
														[ngClass]="answer['state'] == 'WRONG' ? 'highlight-wrong' : ''"
														class="btn btn-sm {{ questionCssClassPrefix }}answer-button btn-danger"
														[attr.data-question-id]="'qna-' + i + '-question'">Onvoldoende</button>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</div>
							<div class="row">
								<table *ngIf="missingStudents.length > 0 && showStudentAnswerNames == true"
									id="unansweredList">
									<tr>
										<th>De volgende student(en) hebben de vraag niet beantwoord:</th>
									</tr>
									<tr>
										<ng-container *ngFor="let student of missingStudents">
											<td>{{student.name}}</td>
										</ng-container>
									</tr>
								</table>
							</div>
							<a href="javascript:void(0)" (click)="navigateToQuestionInModal('prev')"
								class="navigation-arrow previous"
								[ngClass]="currentQuestionPosition == 0 ? 'disabled' : ''">
								<i class="fas fa-chevron-left"></i>
							</a>
							<a href="javascript:void(0)" (click)="navigateToQuestionInModal('next')"
								class="navigation-arrow next"
								[ngClass]="currentQuestionPosition == objKeys(questionsWithAnswers).length - 1 ? 'disabled' : ''">
								<i class="fas fa-chevron-right"></i>
							</a>
						</div>
					</article>
				</div>

				<div class="lesson-container-width pl-md-0 pr-md-0 pl-lg-3 pr-lg-3">
					<section class="lesson-feedback my-3 alert alert-success" *ngIf="feedbackSuccess!=''">
						<div class="feedback-success">{{feedbackSuccess}}</div>
					</section>

					<section class="lesson-feedback lesson-container-width my-5 bg-white p-3 rounded"
						*ngIf="feedbackActive">
						<h3>Jouw feedback</h3>
						<p>Spelfout gezien? Werkt de video niet meer? Of moeten we het op een andere manier uitleggen?
							Geef ons advies!</p>
						<div class="feedback-error alert alert-danger" *ngIf="feedbackError!=''">{{feedbackError}}</div>

						<div class="form-group">
							<textarea *ngIf="item" class="form-control" [(ngModel)]="feedbackDescription"></textarea>
						</div>
						<div class="form-group">
							<button class="btn btn-success" type="button" (click)="sendFeedback()">Verstuur
								feedback</button>
						</div>
					</section>
				</div>

				<div class="lesson-container-width pl-md-0 pr-md-0 pl-lg-3 pr-lg-3">
					<div class="my-5 footerNavigation" *ngIf="lessonCount > 0">
						<div
							*ngIf="currentUser['role'] == 'TEACHER' || currentUser['role'] == 'EDITOR' || currentUser['role'] == 'ADMIN'">
							<a class="px-5 py-4" routerLink="/les/{{item['nextLesson']['id']}}/{{currentStudentId}}"
								style="background-image:url({{item['nextLesson']['image']}});"
								*ngIf="item['nextLesson']">
								<span class="routingText font-weight-bold">Volgende</span>
								<span class="routingTitle">{{item['nextLesson']['name']}}</span>
							</a>
							<a class="px-5 py-4" routerLink="/les/{{item['previousLesson']['id']}}/{{currentStudentId}}"
								style="background-image:url({{item['previousLesson']['image']}});"
								*ngIf="item['previousLesson']">
								<span class="routingText font-weight-bold">Vorige</span>
								<span class="routingTitle">{{item['previousLesson']['name']}}</span>
							</a>
						</div>
						<div *ngIf="currentUser['role'] == 'STUDENT'">
							<a class="px-5 py-4" routerLink="/les/{{item['nextLesson']['id']}}"
								style="background-image:url({{item['nextLesson']['image']}});"
								*ngIf="item['nextLesson']">
								<span class="routingText font-weight-bold">Volgende</span>
								<span class="routingTitle">{{item['nextLesson']['name']}}</span>
							</a>
							<a class="px-5 py-4" routerLink="/les/{{item['previousLesson']['id']}}"
								style="background-image:url({{item['previousLesson']['image']}});"
								*ngIf="item['previousLesson']">
								<span class="routingText font-weight-bold">Vorige</span>
								<span class="routingTitle">{{item['previousLesson']['name']}}</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<div *ngIf="item" [innerHTML]="backgroundColor(item['chapter']['backgroundColor'])"></div>
<span (click)="toTop()" class="back-to-top rounded-circle bg-dark" id="toTop" title="Terug naar boven"><i
		class="fas fa-rocket fa-sm"></i></span>